export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE'
export const LANGUAGE_FAIL   = 'LANGUAGE_FAIL'